import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DemoUiService } from '../../core/demo-ui.service';
@Component({ selector: 'rv-privacy', standalone: true, templateUrl: './privacy.component.html', changeDetection: ChangeDetectionStrategy.OnPush })
export class PrivacyComponent { readonly ui = inject(DemoUiService); }
